import { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { Table, Modal, ModalHeader, ModalBody } from "reactstrap";

import { translations } from './../../i18/translations.js';
import Pager from './../../util/Pager.js';
import Search from './../../util/Search.js';
import { Space } from './../../util/Html.js';
import './MemberSearch.css';

const MemberSearch = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const {user, lang, checkAccess} = useOutletContext();

    const [members, setMembers] = useState([]);
    const [pager, setPager] = useState([]);
    const [query, setQuery] = useState("");
    const [selectedMember, setSelectedMember] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [template, setTemplate] = useState('');

    const pageSize = 20;

    useEffect(() => {
        fetchMembers(pageIndex, query);
    }, [pageIndex, query, user]);

    const fetchMembers = async (pageIndex, queryString) => {
        try {
            const payload = {
                filter: {
                    pageSize: 20,
                    pageIndex: pageIndex,
                    queryString: queryString
                }
            };

            const response = await fetch(`${API_URL}/admin/get_member_list.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setMembers(data.data);
                setPager(data.pagerButtonIndexes);
                setTemplate(data.template);
            }
        } catch (error) {
            console.error("Error fetching members:", error);
        }
    };

    const handleSearch = (query) => {
        setQuery(query);
        setPageIndex(0);
    };

    const handleRowClick = (member) => {
        if (member.statement === "1") {
            setSelectedMember(member);
            setModalOpen(true);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedMember(null);
    };

    return (
            <div className="container mt-4">
            
                <h1 className="mbkegy-content">{translations[lang].member_search}</h1>
            
                <Search placeholder={translations[lang].search_member} handleSearch={handleSearch} />
            
                <Table striped className="mbkegy-table">
                    <thead>
                        <tr>
                            <th style={{width: '35%'}}>{translations[lang].name}</th>
                            <th style={{width: '65%'}}>{translations[lang].institute}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map((member) => (
                                <tr
                                    className={member.statement === '1' ? '' : 'member-disable'}
                                    key={member.id}
                                    onClick={() => handleRowClick(member)}
                                    style={{cursor: member.statement === "1" ? "pointer" : "not-allowed"}}
                                    >
                                    <td>{member.fullname ? member.fullname : <Space />}</td>
                            <td>{member.institute ? member.institute : <Space />}</td>
                            </tr>
                                    ))}
                    </tbody>
                </Table>
            
                <Pager template={`${translations[lang].rows}: ${template}`} pager={pager} handlePageChange={setPageIndex} />
            
                {selectedMember && (
                            <Modal isOpen={modalOpen} toggle={closeModal}>
                                <ModalHeader toggle={closeModal}>{selectedMember.fullname}</ModalHeader>
                                <ModalBody>
                                    <p><strong>{translations[lang].name}:</strong> {selectedMember.fullname || ""}</p>
                                    <p><strong>{translations[lang].institute}:</strong> {selectedMember.institute || ""}</p>
                                    <p><strong>{translations[lang].address}:</strong> {selectedMember.address || ""}</p>
                                    <p><strong>{translations[lang].post}:</strong> {selectedMember.post || ""}</p>
                                    <p><strong>{translations[lang].phone}:</strong> {selectedMember.phone || ""}</p>
                                    <p><strong>{translations[lang].email}:</strong> {selectedMember.email || ""}</p>
                                </ModalBody>
                            </Modal>
                            )}
            </div>
            );
};

export default MemberSearch;
